// Tema chiaro/scuro: scelta ricordata sul dispositivo, applicata prima del primo disegno.
export type Theme = 'light' | 'dark';

// 22/10/2026: chiave nuova perché il tema chiaro torni predefinito per tutti (chi vuole lo scuro lo riattiva dal sole/luna in alto)
const KEY = 'tt.theme.v2';

export function savedTheme(): Theme {
  return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light';
}

export function applyTheme(theme: Theme, persist = false): void {
  document.documentElement.dataset.theme = theme;
  if (persist) localStorage.setItem(KEY, theme);
  // Controlli della finestra (desktop) e colore della barra del browser (web)
  window.tt.setTheme?.(theme).catch(() => undefined);
}
